module.exports = __webpack_public_path__ + "img/glitter_7.4184e997.jpg";